import React from 'react';
import ReactDom from 'react-dom'

class Uploader extends React.Component {
	handleFile = (e) => {
		var reader = new FileReader();
		var file = e.target.files[0];

		if (!file)
			return;

		reader.onload = function (img) {
			ReactDom.findDOMNode(this.refs.in).value = '';
			this.props.onFileChanged(img.target.result);
		}.bind(this);

		reader.readAsDataURL(file);
	}

	render() {
		return (
			<React.Fragment>
				<input ref="in" type="file" accept="image/*" onChange={this.handleFile} />
			</React.Fragment>);
	}
}

export default Uploader;


// WEBPACK FOOTER //
// ./src/fw/forms/controls/avatar/Uploader.js